"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _expert = require("@/api/expert/expert");
var _user = require("@/api/user/user");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "名称/编码"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "150"
      }, {
        name: "邮箱",
        prop: "mail",
        isShow: true,
        width: "150"
      }, {
        name: "身份证号",
        prop: "idCard",
        isShow: true,
        width: "150"
      }, {
        name: "电话",
        prop: "phoneNumber",
        isShow: true,
        width: "150"
      }
      // {
      //   name: "是否禁用",
      //   prop: "isLock",
      //   isShow: true,
      //   width: "100",
      //   isFormats: true
      // }
      ],
      minWidth: 300,
      page: {
        pageNum: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      queryValue: "",
      checkBoxs: []
    };
  },
  methods: {
    // 重置密码
    resetPsd: function resetPsd() {
      var _this = this;
      if (this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (this.checkBoxs.length > 1) {
        return this.$message.error("重置密码仅支持单条数据操作。");
      }
      this.$confirm("确认重置吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _user.resetPsd)({
          id: _this.checkBoxs[0]
        }).then(function (res) {
          if (res.code === 2000) {
            _this.getExpert();
            _this.$message.success("操作成功。");
          }
        });
      }).catch(function () {
        _this.$message.info("取消重置。");
      });
    },
    // 取消禁用
    unLock: function unLock(row) {
      var _this2 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      (0, _user.unLock)({
        idList: id
      }).then(function (res) {
        if (res.code === 2000) {
          _this2.$message.success("操作成功。");
          _this2.getExpert();
        }
      });
    },
    // 禁用
    lock: function lock(row) {
      var _this3 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认禁用吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _user.stopUser)({
          idList: id
        }).then(function () {
          _this3.getExpert();
          _this3.$message.success("操作成功。");
        });
      }).catch(function () {
        _this3.$message.info("取消禁用。");
      });
    },
    // 删除
    deleteById: function deleteById(row) {
      var _this4 = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _user.deleteUser)({
          idList: id
        }).then(function () {
          _this4.getExpert();
          _this4.$message.success("操作成功。");
        });
      }).catch(function () {
        _this4.$message.info("取消删除。");
      });
    },
    // 模糊查询
    search: function search(e) {
      this.queryValue = e.queryValue;
      this.getExpert();
    },
    // 新增按钮
    add: function add() {
      this.$router.push("/technocracyTest/technocracy-add");
    },
    // 编辑
    edit: function edit(e) {
      this.$message.error("当前版本专家暂不允许编辑。");
      console.log(e);
      // this.$router.push("/technocracyTest/technocracy-edit");
    },
    // 获取专家列表
    getExpert: function getExpert() {
      var _this5 = this;
      (0, _expert.expertList)({
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        id: "",
        keyWords: this.queryValue
      }).then(function (res) {
        var data = res.data;
        _this5.totalData = data.total;
        _this5.listData = data.list;
        console.log(data.list);
      });
    },
    // 查看作品
    viewWork: function viewWork(e) {
      this.$router.push({
        path: "/technocracyTest/technocracy-viewWorksList",
        query: {
          id: e.id
        }
      });
    },
    save: function save() {},
    handleSelectionChange: function handleSelectionChange(e) {
      var _this6 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this6.checkBoxs.push(item.id);
      });
    },
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNum = e;
      this.getExpert();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNum = 1;
      this.getExpert();
    }
  },
  created: function created() {
    this.getExpert();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};